import { Box, IconButton, Tooltip } from "@mui/material";
import React, { ReactElement } from "react";

interface MessageButtonMenuProps {
  buttons: Array<{
    icon: ReactElement;
    tooltip: string;
    onClick: () => void;
  }>;
  isVisible?: boolean;
}

export const MessageButtonMenu: React.FC<MessageButtonMenuProps> = ({
  buttons,
  isVisible = true,
}) => {
  return (
    <Box
      sx={{
        position: "absolute",
        bottom: -25,
        left: -8,
        display: "flex",
        gap: 0.5,
        bgcolor: "background.paper",
        padding: "2px",
        borderRadius: 1,
        opacity: isVisible ? 1 : 0,
        transition: "opacity 0.2s ease-in-out",
        pointerEvents: isVisible ? "auto" : "none",
      }}
    >
      {buttons.map((button, index) => (
        <Tooltip key={index} title={button.tooltip}>
          <IconButton
            onClick={button.onClick}
            size="small"
            sx={{
              "&:hover": {
                bgcolor: "action.hover",
              },
            }}
          >
            {button.icon}
          </IconButton>
        </Tooltip>
      ))}
    </Box>
  );
};
